import React from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import userLogo from "../../assets/images/avatars/user.png";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleLogout } from "../../slices/userSlice";


let keycloakEnabled =  process.env.REACT_APP_KEYCLOAK_ENABLED === "true"

const UserAccountDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function logout() {

    if (keycloakEnabled) {
      try {
        window.keycloak.logout()
      }catch(err) {
        console.log({Logout: err});
      }
    }else {
      dispatch(handleLogout()).then(() => {
        navigate("/auth/login");
      });
    }
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle
        placement="bottom-end"
        className="py-0 pe-0"
        caret={false}
      >
        <CAvatar src={userLogo} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">
          {t("Account")}
        </CDropdownHeader>
        <CDropdownItem href="/auth/profile">
          <FontAwesomeIcon className="me-2" icon={faUser} />
          {t("Profile")}
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href="#" onClick={logout}>
          <FontAwesomeIcon className="me-2" icon={faPowerOff} />
          {t("Logout")}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default UserAccountDropdown;
